module.exports = __webpack_public_path__ + "static/media/276-pom7703-chim@2x.28146f99.png";